import React, { useState } from "react";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import AllDriversTab from "./AllDriversTab.js";
import OnDutyTab from "./OnDutyTab.js";
import "./Drivers.css";

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

function Drivers() {
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div className="Trips-container">
            <Typography
                variant="h5"
                component="h1"
                gutterBottom
                className="main-title"
            >
                Drivers
            </Typography>

            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="trip tabs"
                    TabIndicatorProps={{ style: { display: "none" } }}
                    sx={{
                        "& .MuiTab-root": {
                            textTransform: "none",
                            fontWeight: 500,
                            fontSize: "14px",
                            fontFamily: "Poppins, sans-serif",
                            color: "#000",
                            borderBottom: "2px solid transparent",
                            outline: "none",
                        },
                        "& .Mui-selected": {
                            color: "rgba(89, 50, 234, 1)",
                            borderBottom: "2px solid rgba(89, 50, 234, 1)",
                        },
                        "& .MuiTab-root:focus": {
                            outline: "none",
                        },
                    }}
                >
                    <Tab label="All Drivers" {...a11yProps(0)} />
                    <Tab label="On Duty" {...a11yProps(1)} />
                </Tabs>
            </Box>

            <CustomTabPanel value={value} index={0}>
                <AllDriversTab />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
                <OnDutyTab />
            </CustomTabPanel>
        </div>
    );
};

export default Drivers;
